import React from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
import type { Slot } from '../types/slot';
import type { Casino } from '../types/casino';
import { buildAffiliateUrl, getCasinosForSlot } from '../utils/slots';
import { trackEvent } from '../utils/analytics';
interface RealMoneyButtonProps {
  slot?: Slot;
  casino?: Casino;
  label?: string;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}
const sizeClasses = {
  sm: 'h-9 px-3.5 text-sm',
  md: 'h-11 px-5 text-sm',
  lg: 'h-12 px-6 text-base'
};
export function RealMoneyButton({
  slot,
  casino,
  label = 'Speel nu',
  className = '',
  size = 'md'
}: RealMoneyButtonProps) {
  const target = casino ?? (slot ? getCasinosForSlot(slot)[0] : undefined);
  if (!target) return null;
  return <a href={buildAffiliateUrl(target, slot)} target="_blank" rel="sponsored nofollow noopener noreferrer" onClick={() => trackEvent('casino_click', {
    casino_id: target.id,
    casino_name: target.name,
    slot_name: slot?.name,
    slot_rank: slot?.rank,
    provider: slot?.provider,
    link_text: label
  })} className={`inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-lg bg-oranje font-semibold text-white transition-[background-color,transform] duration-150 ease-out hover:bg-oranje-dark active:scale-[0.97] focus:outline-none focus-visible:ring-2 focus-visible:ring-oranje focus-visible:ring-offset-2 ${sizeClasses[size]} ${className}`} aria-label={`${label} bij ${target.name}${slot ? ` – ${slot.name}` : ''} (opent in nieuw venster)`} data-id="element-265" data-mp="pz8oqb0l0lnn">
      {label}
      <ArrowUpRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-266" data-mp="2megh66aknzl5" />
    </a>;
}